import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=3963974d&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"
import style0 from "./DeviceList.vue?vue&type=style&index=0&id=3963974d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963974d",
  null
  
)

export default component.exports